export enum ChecklistTemplateEntryManagerMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT'
}
